/*
 * @Description:
 * @version:
 * @Author: 李云飞
 * @Date: 2023-07-13 16:41:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-05 15:03:12
 */

import axios from "axios";
import { useUserStore } from "@/store/user.js";
import { message } from "ant-design-vue";

const http = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

// 请求拦截配置
http.interceptors.request.use(
  (config) => {
    const token = useUserStore().getToken;
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    message.error(error);
    return Promise.reject(error);
  },
);

// 响应拦截配置
http.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;
    if (res.code && res.code === 1) {
      return Promise.resolve(res);
    }
    message.error(res.msg);
    // 30002, "您还未登录，请先登录！"
    // 30003, "登录失效，请重新登录！"
    if (res.code === 30002 || res.code === 30003) {
      useUserStore().removeUserInfo();
    }
    return Promise.reject(response);
  },
  (error) => {
    // 对响应错误做点什么
    message.error(error.message);
    return Promise.reject(error);
  },
);

/**
 * post请求
 */
export const postAxios = (url, data) => {
  return http.post(url, data);
};

/**
 * get请求
 */
export const getAxios = (url, data) => {
  return http.get(url, { params: data });
};

/**
 * 通过formData上传文件
 */
export const uploadAxios = (apiUrl, file, folderType) => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${apiUrl}?folderType=${folderType}`;
  return http.post(url, formData, {
    transformRequest: [(data) => data],
  });
};
